"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloneAllocationForm = CloneAllocationForm;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var mother_room_1 = require("../../../constants/mother-room");
var clone_batch_1 = require("../../../features/apis/clone-batch");
var api_error_message_1 = require("../../../utils/api-error-message");
var client_scoped_query_1 = require("../../../utils/client-scoped-query");
var button_component_1 = require("../../ui/button-component");
var dropdown_component_1 = require("../../ui/dropdown-component");
var labeled_field_1 = require("../../ui/labeled-field");
var labeled_text_field_1 = require("../../ui/labeled-text-field");
var text_component_1 = require("../../ui/text-component");
var area_select_field_1 = require("./area-select-field");
function CloneAllocationForm(props) {
    var _this = this;
    var cloneBatchId = props.cloneBatchId, facilityId = props.facilityId, remainingQuantity = props.remainingQuantity;
    var DEFAULT_DESTINATION = "NEW_MOTHER";
    var DESTINATION_OPTIONS = [
        { label: "New Mother Plant", value: DEFAULT_DESTINATION },
        { label: "Production", value: "PRODUCTION" },
        { label: "Discard", value: "DISCARD" },
    ];
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var _a = (0, react_1.useState)(DEFAULT_DESTINATION), destination = _a[0], setDestination = _a[1];
    var _b = (0, react_1.useState)("1"), quantity = _b[0], setQuantity = _b[1];
    var _c = (0, react_1.useState)(""), areaId = _c[0], setAreaId = _c[1];
    var _d = (0, react_1.useState)(mother_room_1.DEFAULT_MOTHER_TYPE), motherType = _d[0], setMotherType = _d[1];
    var _e = (0, react_1.useState)(""), reason = _e[0], setReason = _e[1];
    var _f = (0, react_1.useState)(""), notes = _f[0], setNotes = _f[1];
    var _g = (0, react_1.useState)(""), error = _g[0], setError = _g[1];
    var _h = (0, react_1.useState)(""), successMessage = _h[0], setSuccessMessage = _h[1];
    var _j = (0, clone_batch_1.useCreateCloneAllocationMutation)(), createCloneAllocation = _j[0], isSaving = _j[1].isLoading;
    var requestTokenRef = (0, react_1.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var isNewMother = destination === "NEW_MOTHER";
    var isDiscard = destination === "DISCARD";
    // Each new mother plant is one tracked plant, so it always takes exactly one clone.
    var quantityValue = isNewMother ? 1 : Number(quantity);
    var isQuantityValid = Number.isInteger(quantityValue) && quantityValue > 0 && quantityValue <= remainingQuantity;
    var isFormComplete = isQuantityValid && (!isNewMother || !!areaId) && (!isDiscard || !!reason);
    var handleDestinationChange = function (nextDestination) {
        setDestination(nextDestination);
        if (nextDestination === "NEW_MOTHER") {
            setQuantity("1");
        }
    };
    var handleAllocate = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, response, _a, createdSeed, createdMotherPlant, caught_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (requestInFlightRef.current || isSaving) {
                        return [2 /*return*/];
                    }
                    setError("");
                    setSuccessMessage("");
                    if (!clientId) {
                        setError("No active client selected.");
                        return [2 /*return*/];
                    }
                    if (!isFormComplete) {
                        setError(quantityValue > remainingQuantity ? "Only ".concat(remainingQuantity, " clones remain unallocated on this batch.") : "Please complete all required fields.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createCloneAllocation({
                            clientId: clientId,
                            id: cloneBatchId,
                            destination: destination,
                            quantity: quantityValue,
                            area_id: isNewMother ? areaId : undefined,
                            mother_type: isNewMother ? motherType : undefined,
                            reason: isDiscard ? reason : undefined,
                            notes: notes.trim() || undefined,
                        }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to allocate these clones. Please try again.");
                        return [2 /*return*/];
                    }
                    _a = response.content, createdSeed = _a.createdSeed, createdMotherPlant = _a.createdMotherPlant;
                    if (createdSeed) {
                        setSuccessMessage("Added to Starting Material as ".concat(createdSeed.batchID || "a new batch", ". It's ready to plant into a grow cycle."));
                    }
                    else if (createdMotherPlant) {
                        setSuccessMessage("Created mother plant ".concat(createdMotherPlant.motherCode || "", "."));
                    }
                    setDestination(DEFAULT_DESTINATION);
                    setQuantity("1");
                    setAreaId("");
                    setMotherType(mother_room_1.DEFAULT_MOTHER_TYPE);
                    setReason("");
                    setNotes("");
                    return [3 /*break*/, 5];
                case 3:
                    caught_1 = _b.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError((0, api_error_message_1.getApiErrorMessage)(caught_1, "Unable to allocate these clones. Please try again."));
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3", children: [(0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Destination", children: (0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "Destination", options: DESTINATION_OPTIONS, selectedKey: destination, onSelectionChange: handleDestinationChange }) }), (0, jsx_runtime_1.jsx)(labeled_text_field_1.LabeledTextField, { label: "Quantity", type: "number", value: quantity, onChange: setQuantity, placeholder: "Number of clones to allocate", isRequired: true, isDisabled: isNewMother }), isNewMother && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(area_select_field_1.AreaSelectField, { isActive: true, facilityId: facilityId, selectedAreaId: areaId, onSelect: setAreaId, isDisabled: isSaving }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "New Mother Type", children: (0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "New Mother Type", options: mother_room_1.MOTHER_TYPE_OPTIONS, selectedKey: motherType, onSelectionChange: setMotherType }) })] })), isDiscard && ((0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Reason", children: (0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "Reason", placeholder: "Choose a reason", options: mother_room_1.DESTRUCTION_REASON_OPTIONS, selectedKey: reason, onSelectionChange: setReason }) })), (0, jsx_runtime_1.jsx)(labeled_text_field_1.LabeledTextField, { label: "Notes", value: notes, onChange: setNotes, placeholder: "Notes (optional)" }), successMessage && (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "green-700", label: successMessage }), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) })), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Allocate Clones", onPress: handleAllocate, isPending: isSaving, isDisabled: !isFormComplete, className: "self-start" })] }));
}
